import Box from '@mui/material/Box';
import { useState } from 'react';

import { Button } from '@/components/ui/Button';
import { ConfirmDialog } from '@/components/ui/ConfirmDialog';

import { State } from '../State';

type Which = 'plain' | 'destructive' | 'pending' | null;

export function ConfirmDialogExamples() {
  const [open, setOpen] = useState<Which>(null);
  const close = () => setOpen(null);

  return (
    <State
      title="Plain, destructive and pending"
      note="Escape and the backdrop mean no. The pending one closes with Escape."
    >
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Button
          variant="secondary"
          onClick={() => setOpen('plain')}
          data-testid="gallery-confirm-dialog-open-plain-button"
        >
          Open a confirmation
        </Button>
        <Button
          variant="secondary"
          onClick={() => setOpen('destructive')}
          data-testid="gallery-confirm-dialog-open-destructive-button"
        >
          Open a destructive one
        </Button>
        <Button
          variant="secondary"
          onClick={() => setOpen('pending')}
          data-testid="gallery-confirm-dialog-open-pending-button"
        >
          Open one that is waiting
        </Button>
      </Box>

      <ConfirmDialog
        open={open === 'plain'}
        testId="gallery-confirm-dialog-plain-dialog"
        title="Change the web handle?"
        description="Links that use the old handle will stop working."
        confirmLabel="Change it"
        onConfirm={close}
        onCancel={close}
      />

      <ConfirmDialog
        open={open === 'destructive'}
        testId="gallery-confirm-dialog-destructive-dialog"
        title="Remove the logo?"
        description="Supporters will see the organization without it."
        confirmLabel="Remove"
        destructive
        onConfirm={close}
        onCancel={close}
      />

      <ConfirmDialog
        open={open === 'pending'}
        testId="gallery-confirm-dialog-pending-dialog"
        title="Revoke the invitation?"
        description="Both answers are held while the confirmed action is in flight."
        confirmLabel="Revoke"
        pending
        onConfirm={close}
        onCancel={close}
      />
    </State>
  );
}
